/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { IIntegrationType } from "./IntegrationServiceTypes";
import { isNonEmptyObject, isNonEmptyString } from "@adapptio/lib-shared";
import { isSchema } from "@adapptio/lib-blueprint";

export function isIntegrationType(value: unknown): value is IIntegrationType {
	return (
		isNonEmptyObject(value) && isNonEmptyString(value.integrationType) && isSchema(value.optionsSchema)
	);
}
